import React, { useState, useEffect } from "react";

import Swal from "sweetalert2";
import axios from "axios";
import LargeLogo from "../svgs/LargeLogo";
import LargeLogoLight from "../svgs/LargeLogoLight";

//JWT
import jwt_decode from "jwt-decode";

//Services
import api from "../services/api";

//Components
import {
  Input,
  Button
} from "../components";

//React router
import {
  Link
} from "react-router-dom";

import {
  useForm
} from "react-hook-form";

import {
  yupResolver
} from "@hookform/resolvers/yup";

import * as yup from "yup";

//Context
import {
  useAuth
} from "../providers/auth";

import useLocalStorage from "use-local-storage";

const schema = yup.object({
  email: yup.string().email("Preencha um e-mail válido.").required("O campo e-mail precisa ser preenchido."),
  password: yup.string().min(4, "Minímo 4 caracteres.").max(16, "Máximo 16 caracteres.").required("A senha é necessária.")
}).required();

const SignIn = () => {
  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm({ resolver: yupResolver(schema) });

  const {
    setUser
  } = useAuth();

  /**
   * IP
   */
  const [ip, setIP] = useState('');

  async function getIpInfo() {
    try {
      //var response = await axios.get("http://ip-api.com/json");
      setIP('201.48.245.226');
    } catch (e) {
      console.error(e);
    }
  }

  useEffect(() => {
    getIpInfo();
  }, []);
  /**
   * IP
   */

  const [loading, setLoading] = useState(false);

  const onSubmit = async data => {
    setLoading(true);

    try {
      data.ip = '201.48.245.226';

      const response = await api.post("/login", data);

      if (response.data.error) {
        let icon = "error";
        let title = "Ocorreu um erro";
        let text = response.data.message;

        openAlert(icon, title, text);

        setLoading(false);
      } else {
        const { admin_id, name, group_id, notifications } = jwt_decode(response.data.token);

        const newUser = {
          id: admin_id,
          name: name,
          group_id: group_id,
          notifications: notifications,
          token: response.data.token
        };

        setUser(newUser);

        localStorage.setItem("user", JSON.stringify(newUser));
      }

    } catch (e) {
      let icon = "error";
      let title = "Ocorreu um erro";
      let text = e.response?.data?.message || "Erro interno do servidor.";

      openAlert(icon, title, text);
    } finally {
      setLoading(false);
    }
  };

  const Toast = Swal.mixin({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: false,
    didOpen: (toast) => {
      toast.addEventListener("mouseenter", Swal.stopTimer)
      toast.addEventListener("mouseleave", Swal.resumeTimer)
    }
  });

  const openAlert = (icon, title, text) => {
    Toast.fire({
      icon,
      title,
      text
    });
  };

  const [theme] = useLocalStorage("theme");

  return (
    <div className="container-signin" data-theme={theme}>
      <a href="#" className="mb-20">
        {theme === "dark" ? <LargeLogoLight /> : <LargeLogo />}
      </a>

      <div className="white-box mt-1">
        <form onSubmit={handleSubmit(onSubmit)}>
          <Input
            label="Endereço de e-mail"
            type="text"
            placeholder="voce@usadaomaquinas.com.br"
            name="email"
            register={register}
            error={errors.email}
          />

          <Input
            label="Senha de acesso"
            type="password"
            placeholder="exemplo123"
            custom="mb-3"
            name="password"
            register={register}
            error={errors.password}
          />

          <div className="mt-20">
            <Button
              title="Acessar conta"
              color="green"
              width="full"
              loading={loading}
            />
          </div>
        </form>
      </div>
      <Link className="forgot-link text-color" to="/reset-password">
        Esqueci minha senha
      </Link>
    </div>
  );
}

export default SignIn;
